import React from 'react';

const BS_Templates = () => {
    return (
        <div>
            <h1>BS_Templates Component</h1>
            <p>Content coming soon...</p>
        </div>
    );
}

export default BS_Templates;
